import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WebAppConfigService } from '../../core/services/webapp-config.service';
import { MetaService } from '../../core/services/meta.service';

@Component({
  selector: 'app-maintenance',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './maintenance.html',
  styleUrls: ['./maintenance.css']
})
export class MaintenanceComponent implements OnInit {
  private webAppConfig = inject(WebAppConfigService);
  private metaService = inject(MetaService);
  
  logoUrl: string = '';
  contactEmail: string = '';
  contactPhone: string = '';

  ngOnInit(): void {
    this.metaService.resetToDefault();
    const config = this.webAppConfig.config();
    if (config) {
      this.logoUrl = config.url_logo || '';
      this.contactEmail = config.support_email || '';
      this.contactPhone = config.contact_phone || '';
    }
  }
}
